<template>
  <div class="divNav">
    <span @click="() => {$router.push('/')}" class="spanSubject">首页 / </span>
    <span @click="navClick" class="spanSubject">{{subject}}</span>
    <span class="spanSplit"> / </span>
    <span class="spanName">{{ project }}</span>
  </div>
</template>

<script>
export default {
  props: {
    subject: {
      type: String,
      default: "",
    },
    project: {
      type: String,
      default: "",
    },
    routerLink: {
      type: Object,
      default: () => {},
    },
  },
  methods: {
    navClick() {
      const pathList = {
        "/homeWeb": "前端学科",
        "/ homeAi": "人工智能",
        "/homePython": "Python学科",
        "/homeBigData": "大数据学科",
        "/java": "Java学科"
      }
      const path = this.routerLink.path
      this.$trackEvent(pathList[path], "点击", pathList[path])
      this.$router.push(this.routerLink);
    },
  },
};
</script>

<style lang="scss" scoped>
.divNav {
  text-align: right;
  // font-size: 16px;
  font-family: PingFang SC;
  font-weight: 600;
  color: rgba(255, 255, 255, 1);
  z-index: 10;
  .spanSubject {
    cursor: pointer;
    // &:hover{
    //   color: #1086ff;
    // }
  }
  .spanSplit {
    margin-left: 2px;
    margin-right: 2px;
  }
  .spanName {
    font-weight: 300;
    font-size: 14px;
  }
}
</style>
